var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgG5A(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.01 21.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-G5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.59,0H8.46A2.26,2.26,0,0,0,6.54,1.06L0,10.88l6.54,9.8a2.26,2.26,0,0,0,1.92,1.07H26.59A2.42,2.42,0,0,0,29,19.34V2.42A2.43,2.43,0,0,0,26.59,0Zm0,19.34h-18L2.9,10.88,8.53,2.42H26.59Zm-14-2.42,4.34-4.34,4.34,4.34,1.7-1.7-4.34-4.34L23,6.54l-1.7-1.71L16.92,9.17,12.58,4.83l-1.7,1.71,4.34,4.34-4.34,4.34Z",
    transform: "translate(0 0)",
    fill: "#4c5666"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgG5A);
export default __webpack_public_path__ + "static/media/G5A.d2e499f537a5888bd9556a0587bef090.svg";
export { ForwardRef as ReactComponent };